<template>
    <SectionWrapper borderPosition="bottom">
        <template #title>
            <br />
            {{ $t('payment_methods') }}

            <div v-if="this.error" class="mt-2 text-red text-xs">
                <p>
                    {{ $t('choose_payment_method') }}
                </p>
            </div>
        </template>

        <template #content>
            <br />
            <div v-if="getPaymentMethods?.data?.length">
                {{ $t('select_existing_payment_method') }}<br /><br />
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    <SinglePaymentMethod
                        v-for="paymentMethod in getPaymentMethods.data"
                        :key="paymentMethod.id"
                        :showToggle="true"
                        :active="selectedExistingPaymentMethod === paymentMethod.id"
                        :paymentMethod="paymentMethod"
                        @click="selectExistingPaymentMethod(paymentMethod.id)"
                    >
                    </SinglePaymentMethod>
                </div>
                <hr class="my-6 border-gray-300" />
                {{ $t('select_new_payment_method') }}<br /><br />
            </div>

            <div class="grid grid-cols-1 gap-4">
                <NewPaymentMethod
                    v-for="newPaymentMethod in newPaymentMethods"
                    :key="newPaymentMethod.id"
                    :showToggle="true"
                    :isOverview="false"
                    :paymentMethod="newPaymentMethod"
                    :selectedNewPaymentMethod="selectedNewPaymentMethod"
                    @update:selectedNewPaymentMethod="selectNewPaymentMethod(newPaymentMethod.id)"
                />
            </div>
        </template>
    </SectionWrapper>
</template>

<script>
import i18next from 'i18next';
import { wTrans } from 'laravel-vue-i18n';
import { mapActions, mapGetters } from 'vuex';

export default {
    data: () => ({
        loading: false,
        type: null,
        open: true,
        newPaymentMethods: [
            {
                name: 'payment_creditcard',
                id: 'CREDITCARD'
            },
            {
                name: wTrans('PayPal'),
                id: 'PAYPAL'
            },
            {
                name: wTrans('Google Pay'),
                id: 'GOOGLEPAY'
            },
            {
                name: wTrans('Apple Pay'),
                id: 'APPLEPAY'
            }
        ]
    }),
    props: {
        selectedNewPaymentMethod: null,
        selectedExistingPaymentMethod: null,
        error: Boolean,
        paymentMethodSelected: Boolean
    },
    mounted() {
        // check if direct debit is enabled or filter it out
        this.directDebitEnabled = window.meta.direct_debit_enabled;
        if (!this.directDebitEnabled) {
            this.newPaymentMethods = this.newPaymentMethods.filter((method) => method.id !== 'DIRECTDEBIT');
        }

        const currentDomain = window.location.hostname;
        // if (currentDomain.includes('hkcmglobal')) {
        //     this.newPaymentMethods = this.newPaymentMethods.filter(method => method.id !== 'PAYPAL');
        // }

        this.$store.dispatch('payment_methods/index').then(() => {
            this.setPrimaryPaymentMethod();
        });
    },
    methods: {
        ...mapActions('cart', ['index']),

        setPrimaryPaymentMethod() {
            const primaryMethod = this.getPaymentMethods.data.find((method) => method.primary);

            if (primaryMethod) {
                this.$emit('update:selectedExistingPaymentMethod', primaryMethod.id);
            }
        },

        selectNewPaymentMethod(paymentMethodId) {
            this.$emit('update:selectNewPaymentMethod', paymentMethodId);
        },

        selectExistingPaymentMethod(paymentMethodId) {
            this.$emit('update:selectExistingPaymentMethod', paymentMethodId);
        }
    },

    computed: {
        ...mapGetters('cart', ['get', 'getItems']),
        ...mapGetters('user', ['isLoggedIn']),
        ...mapGetters('payment_methods', {
            getPaymentMethods: 'get'
        })
    },

    emits: ['update:selectNewPaymentMethod', 'update:selectExistingPaymentMethod']
};
</script>
